export class ListService {
    static normalize(item) {
        if (item === null) {
            return {
                divider: true
            };
        }
        else if (Array.isArray(item) && (item.length === 1 || item.length === 2)) {
            if (item.length === 2) {
                return {
                    icon: item[0],
                    label: item[1],
                    divider: true
                };
            }
            return {
                label: item[0],
                divider: true
            };
        }
        else if (typeof item === 'string') {
            return {
                label: item
            };
        }
        return item;
    }
    constructor(items = []) {
        this.items = items.map(ListService.normalize);
    }
    itemClick(item) {
        console.log(item);
    }
}
//# sourceMappingURL=list.js.map